import { ApiClient } from '@billy/auth-api-sdk';

import { API_URL } from '@/config';

export const authApiClient = new ApiClient({ BASE: API_URL });
